import { useState, useEffect } from 'react';
import { Button } from '../ui';

interface CleanupBannerProps {
  onStartCleanup: () => void;
}

export function CleanupBanner({ onStartCleanup }: CleanupBannerProps) {
  const [showBanner, setShowBanner] = useState(false);
  const [importCount, setImportCount] = useState(0);

  useEffect(() => {
    const justImported = localStorage.getItem('ondeck-just-imported');
    const count = localStorage.getItem('ondeck-last-import-count');

    if (justImported === 'true') {
      setShowBanner(true);
      setImportCount(parseInt(count || '0', 10));
    }
  }, []);

  const handleDismiss = () => {
    localStorage.removeItem('ondeck-just-imported');
    localStorage.removeItem('ondeck-last-import-count');
    setShowBanner(false);
  };

  const handleStartCleanup = () => {
    handleDismiss();
    onStartCleanup();
  };

  if (!showBanner) return null;

  return (
    <div className="mb-6 p-4 bg-purple-50 dark:bg-purple-900/20 border border-purple-200 dark:border-purple-800 rounded-xl">
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-3">
          <span className="text-2xl">✨</span>
          <div>
            <h3 className="font-semibold text-purple-900 dark:text-purple-100">
              {importCount > 0
                ? `${importCount} contacts imported!`
                : 'Contacts imported!'}
            </h3>
            <p className="text-sm text-purple-700 dark:text-purple-300 mt-1">
              Want AI to clean up the data? We'll review each contact and suggest improvements
              like name formatting, phone standardization, and stage assignments.
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <button
            onClick={handleDismiss}
            className="text-sm text-purple-600 dark:text-purple-400 hover:underline"
          >
            Maybe Later
          </button>
          <Button size="sm" onClick={handleStartCleanup}>
            Clean Up Now
          </Button>
        </div>
      </div>
    </div>
  );
}
